import React from "react";
import { AddCircle } from "@mui/icons-material";

export default function Navigation({ groupHandler }) {
  return (
    <div className="navigation">
      <span onClick={groupHandler}>
        <AddCircle />
        Group
      </span>
    </div>
  );
}
